import React, {useEffect, useState} from 'react';
import {
    Button,
    Popup,
    Flex,
    Goods,
    IconButton,
    Tabs,
    Tab,
    Price,
    Tag,
    Search,
    FlexItem
} from '@chatui/core';


function GoodsSelect(props) {
    /*
    * getGoodsList: () => Promise({GoodsCategory: GoodsProps[]})
    *
    * GoodsCategory: string
    *
    * GoodsProps: {
    * name: string,
    * price: float,
    * number: int,
    * img: string(url),
    * desc: string
    * }
    * */

    const initGL = {
        'Substantial Dish': [{
            "name": "laziji",
            "price": "28",
            "desc": "spicy chicken",
        },
            {
                "name": "shuizhuyu",
                "price": "38",
                "desc": "spicy fish",
            }],
        'drinks': [{
            "name": "Coca cola",
            "price": "5",
            "desc": "Coca cola",
        }],
        'Main Food': [{
            "name": "rice",
            "price": "2",
            "desc": "rice",
        }],
        "Stir-Fried Dish": [{
            "name": "yuxiangrousi",
            "price": "19",
            "desc": "carrot and pork, with sweet and sour flavour.",
        }]
    }
    const [openPop, setOpenPop] = useState(false);
    const [goodsList, setGoodsList] = useState(initGL);
    const categories = Object.keys(goodsList);
    const initSelectedGoods = {} //
    for (let k in categories) {
        initSelectedGoods[categories[k]] = {}
    }
    const [selectedGoods, setSelectedGoods] = useState(initSelectedGoods);
    const [goodsNum, setGoodsNum] = useState(0);
    const [openCart, setOpenCart] = useState(false);
    const [sumPrice, setSumPrice] = useState(0);

    const SelectGoods = (category, index) => {
        // console.log(selectedGoods);
        const newSelectedGoods = JSON.parse(JSON.stringify(selectedGoods));
        if (!newSelectedGoods[category][index]) {
            newSelectedGoods[category][index] = 1
        }
        else {
            newSelectedGoods[category][index] += 1
        }
        setSelectedGoods(newSelectedGoods);
        setGoodsNum(goodsNum+1);
        setSumPrice(sumPrice+parseFloat(goodsList[category][index].price));
    }

    const onAcknowledge = () => {
        const gl = [];
        for (let k=0; k<categories.length; k++) {
            const idxs = Object.keys(selectedGoods[categories[k]]);
            for(let i in idxs) {
                let g = {...goodsList[categories[k]][idxs[i]]};
                g['number'] = selectedGoods[categories[k]][idxs[i]];
                g['img'] = '/images/default.png';
                gl.push(g);
            }
        }
        if (props.onAcknowledge) {
            props.onAcknowledge(gl);
        }
    }


    const clearCart = () => {
        setSelectedGoods(initSelectedGoods);
        setSumPrice(0);
        setGoodsNum(0);
    };

    const getGoodsList = () => {
        if (props.getGoodsList) {
            props.getGoodsList()
                .then(gl=>{
                    setGoodsList(gl);
                })
                .catch(error=>{
                    console.log(error);
                });
        }
    }
    useEffect(() => {
        getGoodsList();
    }, []);
    return (
        // <div>
            <Popup
                active={props.active}
                onClose={props.onClose? props.onClose: ()=>{}}
                title={props.title? props.title: "Select Products"}
                height={80}
            >

                {Object.keys(goodsList).length>0? (
                    <div>
                        <Popup
                            active={openCart}
                            onClose={()=>setOpenCart(false)}
                            title={"Cart"}
                            height={40}
                        >
                            <IconButton size={'lg'}
                                        style={{'position': 'fixed', 'right': '50px', 'top':'18px'}}
                                        icon={'dash-circle-fill'}
                                        onClick={()=>clearCart()}
                            ></IconButton>
                            {categories.map((category, c_index)=>(

                                Object.keys(selectedGoods[category]).map((k, index)=>(
                                    <Goods
                                        key={c_index.toString()+index.toString()}
                                        type={'products'}
                                        name={goodsList[category][index].name}
                                        price={goodsList[category][index].price}
                                        desc={goodsList[category][index].desc}
                                        count={selectedGoods[category][index]}
                                        img={'/images/default.png'}
                                        currency={'$'}
                                    ></Goods>
                                    )
                                )
                            ))}
                        </Popup>
                        <Search placeholder={'Input key words of target products...'}></Search>
                        <Tabs scrollable>
                            {Object.keys(goodsList).map((category, index)=>(
                            <Tab label={category} key={index}>
                                {goodsList[category].map((item, goods_idx)=>(
                                    <Goods
                                        key={goods_idx}
                                        type={'products'}
                                        name={item.name}
                                        price={item.price}
                                        desc={item.desc}
                                        img={'/images/default.png'}
                                        currency={"$"}
                                        action={{icon: 'cart', onClick: ()=>SelectGoods(category, goods_idx)}}
                                    ></Goods>
                                ))}
                            </Tab>
                        ))}
                        </Tabs>
                        <Flex center style={{
                            "position": "fixed",
                            "bottom": "0px",
                            'backgroundColor': '#f1f1f1',
                            "width": "100%",
                            'height': '50px'
                        }}>
                            <FlexItem>
                            <Button size={"lg"}
                                    icon={'shopping-bag-fill'}
                                    style={{"width": "80px"}}
                                    onClick={() => setOpenCart(true)}
                            >
                                {goodsNum <= 0 ? '' : (
                                    <Tag color={'primary'}>
                                        {goodsNum}
                                    </Tag>
                                )}
                            </Button>
                            </FlexItem>
                            <FlexItem>
                                Total Price: <Price style={{'fontSize': '1.2em'}} price={sumPrice} currency="$" />
                            </FlexItem>

                            <Button onClick={onAcknowledge} size={'lg'}>Okay</Button>
                        </Flex>
                    </div>
                ):(
                    <div>

                    </div>
                )}

            </Popup>
        //    <Button onClick={()=>setOpenPop(true)}>choose products</Button>
        // </div>
    );
}

export default GoodsSelect;